import Image from 'next/image';
import type { ReactNode } from 'react';

import { Button } from '@ria-client/tw-shadcn/components/button';
import { AccessibleHiddenText } from '@ria-client/tw-shared-ui';
import { ContentLink } from './content-link';

export interface FeaturedMedia {
  altText: string | null;
  width: number;
  height: number;
  sourceUrl: string;
  srcSet: string;
}

export interface HorizontalHouseAdProps {
  headline: string;
  body: string;
  ctaHref?: string;
  ctaNode?: ReactNode;
  ctaText: string;
  featuredMedia?: FeaturedMedia;
}

export function HorizontalHouseAd({
  headline,
  body,
  ctaHref,
  ctaNode,
  ctaText,
  featuredMedia,
}: HorizontalHouseAdProps) {
  return (
    <div className="flex flex-col-reverse items-center justify-between gap-x-8 gap-y-4 rounded-sm border border-border px-8 md:flex-row md:items-end">
      <div className="mb-8 flex flex-col items-center md:mt-8 md:items-start">
        <div className="typography-text-bold mb-2 text-center md:text-left">{headline}</div>
        <div className="typography-text mb-4 text-center md:text-left">{body}</div>
        {ctaHref ? (
          <Button asChild fullWidth={false}>
            <ContentLink href={ctaHref}>
              {ctaText}
              <AccessibleHiddenText as="span">on NerdWallet&apos;s site</AccessibleHiddenText>
            </ContentLink>
          </Button>
        ) : (
          ctaNode
        )}
      </div>
      <div className="mt-1 flex">
        {featuredMedia?.sourceUrl && (
          <Image
            alt={featuredMedia.altText || headline}
            height={featuredMedia.height}
            src={featuredMedia.sourceUrl}
            style={{ height: 'auto' }}
            width={Math.min(250, (featuredMedia.width / featuredMedia.height) * 200)}
          />
        )}
      </div>
    </div>
  );
}
